const ClipboardCopy = {
    copy(elem) {
        if (typeof elem === 'string') {
            let textArea = document.createElement("input");

            textArea.style.position = 'fixed';
            textArea.style.top = 50;
            textArea.style.left = 0;
            textArea.style.zIndex = -1;

            textArea.value = elem;

            document.body.appendChild(textArea);

            textArea.select();

            _copy();

            document.body.removeChild(textArea);
        } else {
            elem.select();

            _copy();
        }
    }
};

const _copy = () => {
    try {
        document.execCommand('copy');
    } catch(err) {
        console.log('Oops, unable to copy');
    }
};

export default ClipboardCopy;
